export class VoidStatus {
  id: number;
  description: string;
  object: string;

  constructor() {}
}
